module.exports = __webpack_public_path__ + "src/favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./src/favicon.ico
// module id = 1143
// module chunks = 0